export enum SportTypeEnum {
  FOOTBALL = "FOOTBALL",
  BASKETBALL = "BASKETBALL",
  VOLLEYBALL = "VOLLEYBALL",
  AMERICAN_FOOTBALL = "AMERICAN_FOOTBALL",
  BASEBALL = "BASEBALL",
  ICE_HOCKEY = "ICE_HOCKEY",
  HANDBALL = "HANDBALL",
}
